import { IRequestWrap } from '../../../server/IServer';
import { EN_APP_DEVICE } from './EN_APP_DEVICE';

export const getAppDevice = (req: IRequestWrap): EN_APP_DEVICE | null => {
  const appDevice = (
    req.headers?.['app-device'] ||
    req.headers?.['app_device'] ||
    req.cookies?.['app-device'] ||
    ''
  ).toLowerCase();

  return appDevice === EN_APP_DEVICE.ANDROID || appDevice === EN_APP_DEVICE.IOS ? (appDevice as EN_APP_DEVICE) : null;
};
